import { AdminMiniData } from './admin';
import { CountryMiniData } from './country';
import { Counts, DocumentStatus, Error, UserAccountStatus, UserPinStatus } from './data';
import { UserBankAccountData } from './UserBankAccount';
import { UserCompanyDetailsData } from './UserCompanyDetails';
import { UserComplianceDetailsData } from './UserCompliance';
import { UserContactPersonData } from './UserContactPerson';
import { UserDocumentData } from './UserDocument';
import { UserInternationalBData } from './UserInternationalB';
import { UserLocalBranchData } from './UserLocalBranch';
import { UserOwnerData } from './UserOwner';
import { UserRelatedEntityData } from './UserRelatedEntity';
import { UsersDirectorDetailsData } from './UsersDirectorDetails';
import { UserTransactionDetailsData } from './UserTransactionDetails';

export class User {
  success: true|false;
  error: Error;
  results: string;
  counts: Counts;
  data: UserData[] = [];
}

export class OneUser {
  success: true|false;
  error: Error;
  results: string;
  data: UserData;
}

export class UserData {
    ref: number;
    lastName: string;
    firstName: string;
    phone: string;
    email: string;
    publicKey: string;
    pinStatus: UserPinStatus;
    file: string;
    country: CountryMiniData;
    status: UserAccountStatus;
    companyDetails: UserCompanyDetailsData;
    transaction: UserTransactionDetailsData;
    compliance: UserComplianceDetailsData;
    directorDetails: UsersDirectorDetailsData[] = [];
    contactPersons: UserContactPersonData[] = [];
    ownership: UserOwnerData[] = [];
    localSubsidiary: UserLocalBranchData[] = [];
    intSubsidiary: UserInternationalBData[] = [];
    relatedEntity: UserRelatedEntityData[] = [];
    bankAccounts: UserBankAccountData[] = [];
    documents: UserDocumentData[] = [];
    validation: Validation;
    createdBy: AdminMiniData;
    lastModifiedBy: AdminMiniData;
    created: string;
    lastModified: string;

    constructor() {
      this.validation = new Validation();
      this.country = new CountryMiniData();
      this.companyDetails = new UserCompanyDetailsData();
      this.status = new UserAccountStatus();
      this.createdBy = new AdminMiniData();
      this.lastModifiedBy = new AdminMiniData();
        this.pinStatus = new UserPinStatus();
    }
  }

  export class Validation {
    companyDetails: {
      status: DocumentStatus;
      comment: string;
    }
    directorDetails: {
      status: DocumentStatus;
      comment: string;
    }
    contactPersonDetails: {
      status: DocumentStatus;
      comment: string;
    }
    ownershipDetails: {
      status: DocumentStatus;
      comment: string;
    }
    transactionDetails: {
      status: DocumentStatus;
      comment: string;
    }
    complianceDetails: {
      status: DocumentStatus;
      comment: string;
    }
    uploadFiles: {
      status: DocumentStatus;
      comment: string;
    }
    status: DocumentStatus;
    validatedBy: string;
    lastModified: string;


    constructor() {
      this.status = new DocumentStatus();
    }
  }